import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { Language } from "../../../Libs/Devices/Language";
import api from "../../../Libs/Api/AxiosConfig";
import { DEFAULT_LANG as DEPLOY_LANG } from "../../../Libs/Api/Config";
import { applyBrand } from "../../../Libs/Branding/brands";
import { setLocaleRows } from "../../../Libs/i18n/localeId";

/** Daha önce seçilmiş dil (I18nContext ile aynı anahtar). */
const savedLang = () => {
    try { return localStorage.getItem('bonus.lang') || null; } catch { return null; }
};

export const getApps = createAsyncThunk('Apps/getApps', async () => {
    // Kayıtlı dil > DAĞITIM dili > tarayıcı dili > tr.
    // SIRA I18nContext.resolveInitialLang ile BİREBİR AYNI olmalı: burada seçilen dil
    // InitApp'e gidiyor ve dönen `lang` state'e yazılıyor; I18nProvider de state'i
    // kendi hesabından ÖNCE okuyor. İkisi ayrışırsa dağıtım dili sessizce ezilir —
    // Holideus RU'da tam olarak bu oldu: arayüz Rusça yerine tarayıcı diliyle açıldı.
    const lang = savedLang() || DEPLOY_LANG || Language()[0] || 'tr';

    const res = await api.post(`/User/Init/InitApp`, { browserLanguage: lang });

    // Marka (logo/renk/başlık) API'den gelir — CSS değişkenlerine HEMEN yaz ki
    // render'a kadar geçen sürede yanlış marka görünmesin. index.js açılışta
    // varsayılanı (Tourzone) uygular; burada gerçek marka üzerine biner.
    try { applyBrand(res?.data?.payload?.branding); } catch (e) { /* yoksay */ }

    return res.data;
});

export const AppSlice = createSlice({
    name: "Apps",
    initialState: {
        loading: true,

        selectedCurrency: "",
        selectedLanguage: "",
        companyTypes: [],
        // InitApp açılış verisi (I18nContext bunları okur — localStorage yok).
        translate: {},
        language: [],
        lang: null,
        // Eski frontend uyumu (ürün dili seçici vb. Apps.locales okur).
        locales: [],
        // Dağıtım markası (InitApp -> branding). null iken bileşenler DEFAULT_BRANDING kullanır.
        branding: null,
    },
    reducers: {
        errorReducer: (state, action) => {
            state.error = true;
            state.errorData = action;
        },
        errorCloseReducer: (state) => {
            state.error = false;
        },
        setCaptcha: (state, action) => {
            state.captchaToken = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getApps.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getApps.fulfilled, (state, { payload }) => {
            const pl = payload?.payload || {};

            // i18n: çeviri map'i + dil listesi + aktif dil (I18nContext okur).
            state.translate = (pl.translate && typeof pl.translate === 'object') ? pl.translate : {};
            state.language = Array.isArray(pl.language) ? pl.language : [];
            state.locales = Array.isArray(pl.language) ? pl.language : [];
            // Dil kodu → locale id haritası (Clientlanguage header / içerik dili).
            setLocaleRows(state.locales);
            state.lang = pl.lang || null;
            // Signup formu için şirket tipleri (Redis + Init'ten gelir).
            state.companyTypes = Array.isArray(pl.companyTypes) ? pl.companyTypes : [];
            // Marka: bileşenler mergeBranding(Apps.branding) ile DEFAULT üzerine bindirir.
            state.branding = (pl.branding && typeof pl.branding === 'object') ? pl.branding : null;

            state.loading = false;
        });
        builder.addCase(getApps.rejected, (state) => {
            state.loading = false;
        });
    },
});

export const { errorReducer, errorCloseReducer, setCaptcha } = AppSlice.actions;

export const AppReducer = AppSlice.reducer;
